import React from "react";
import styles from "./citySection.module.scss";
import "lazysizes";
import Imgix, { buildURL } from "react-imgix";
import LocalizedExternalLink from "@components/LocalizedExternalLink/localizedExternalLink";

const CitySection = ({ name, slug, cityImage, locale }) => (
  <li key={slug} className={styles.citySection}>
    <LocalizedExternalLink
      url={`${process.env.HOMEPAGE_URL}`}
      path={`/accommodation/${slug}`}
      locale={locale}
      title={name}
    >
      <Imgix
        className="lazyload"
        src={cityImage.url}
        alt={cityImage.alt ? cityImage.alt : name}
        sizes="(min-width: 36em) 350px, 90vw"
        imgixParams={{ auto: 'compress,format' }}
        attributeConfig={{
          src: 'data-src',
          srcSet: 'data-srcset',
          sizes: 'data-sizes',
        }}
        htmlAttributes={{
          src: buildURL(cityImage.url, {
            auto: 'compress,format',
            blur: 50,
            w: 80,
          }),
        }}
      />
      <h4>{name}</h4>
    </LocalizedExternalLink>
  </li>
);

export default CitySection;
